import axiosInstance from '../utils/AxiosConfig';

export const getAllDiscounts = async (locationId) => {
    try {
        const response = await axiosInstance.get(`/discounts`, {
            params: {
                locationId: locationId
            }
        });
        return response.data.data;
    } catch (error) {
        console.error('Error fetching categories:', error);
        return [];
    }
};

export const createDiscount = async (data) => {
    try {
        await axiosInstance.post(`/discounts`, data);
        return true;
    } catch (error) {
        if (error.response?.data?.error_message || error.response?.data?.message) throw error;
        return false;
    }
};
  
export const updateDiscount = async (id, data) => {
    try {
        await axiosInstance.put(`/discounts/${id}`, data);
        return true;
    } catch (error) {
        if (error.response?.data?.error_message || error.response?.data?.message) throw error;
        return false;
    }
};  

export const deleteDiscount = async (id) => {
    try {
        const response = await axiosInstance.delete(`/discounts/${id}`);
        return response.data?.error === false;
    } catch (error) {
        console.error('Error deleting discount:', error);
        return false;
    }
};

export const pauseDiscount = async (id) => {
    try {
        const response = await axiosInstance.put(`/discounts/pause/${id}`);
        return response.data.error == false;
    } catch (error) {
        console.error('Error fetching categories:', error);
        return [];
    }
};

export const resumeDiscount = async (id) => {
    try {
        const response = await axiosInstance.put(`/discounts/resume/${id}`);
        return response.data.error == false;
    } catch (error) {
        console.error('Error fetching categories:', error);
        return [];
    }
};

export const setDiscountValidForWeb = async (id, validForWeb) => {
    try {
        await axiosInstance.put(`/discounts/${id}/valid-for-web`, { valid_for_web: validForWeb });
        return true;
    } catch (error) {
        console.error('Error updating valid for web', error);
        return false;
    }
};

export const validateDiscountCode = async (locationId, code) => {
    try {
        // Codificar el código para asegurar que se envíe correctamente en la URL
        const encodedCode = encodeURIComponent(code.trim());
        console.log('Código original:', code, 'Código codificado:', encodedCode); // Debug
        const response = await axiosInstance.get(`/discounts/validate/${encodedCode}`, {
            params: {
                locationId: locationId
            },
            // Los códigos de campañas (bienvenida/cartilla) se validan en
            // /sales/calculate. Esta consulta solo cubre descuentos tradicionales,
            // por lo que un 400 aquí es un resultado esperado, no un error a mostrar.
            skipSnackbar: true
        });
        console.log('Respuesta completa del servidor:', response.data); // Debug
        
        // Verificar la estructura de la respuesta
        if (response.data) {
            // Si tiene la propiedad data con contenido, usar ese valor
            if (response.data.data !== undefined && response.data.data !== null) {
                console.log('Código válido, datos del descuento:', response.data.data);
                return response.data.data;
            }
            
            // Si tiene propiedades del descuento directamente (id, code, percentage, etc.)
            // significa que el descuento está en el nivel superior
            if (response.data.id || response.data.code || response.data.percentage !== undefined) {
                console.log('Código válido, datos del descuento en nivel superior:', response.data);
                return response.data;
            }
            
            // Si solo tiene error: false y status_code: 200 pero no tiene data ni propiedades del descuento
            // significa que el código no existe o no es válido para esta ubicación
            if (response.data.error === false && response.data.status_code === 200) {
                console.log('Respuesta exitosa pero sin datos del descuento - código inválido o no existe');
                return null;
            }
        }
        
        console.log('Código no encontrado o inválido');
        return null;
    } catch (error) {
        console.error('Error validando código de descuento:', error);
        console.error('Status:', error.response?.status); // Debug
        console.error('Detalles del error:', error.response?.data); // Debug
        console.error('URL solicitada:', error.config?.url); // Debug
        // Si es un 404, el código no existe
        if (error.response?.status === 404) {
            return null;
        }
        // Para otros errores, retornar null también
        return null;
    }
};
